import { QueryParams, TAG_TYPES } from 'types';
import { baseApi } from './index';
import { getQueryParams } from 'utils';
import { TransactionMethod } from 'models';

const urlEndpoint = `${process.env.REACT_APP_BASE_URL}/transaction-methods`;
const tagType = TAG_TYPES.TransactionMethod;

const transactionMethodApiServicer = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllTransactionMethods: builder.query<
      {
        data: {
          rows: TransactionMethod[];
          count: number;
        };
        success: boolean;
      },
      { query: QueryParams }
    >({
      query: (params) => {
        const query = getQueryParams(params?.query);
        return {
          url: `${urlEndpoint}?${query}`,
          method: 'GET',
        };
      },
      providesTags: (result) => {
        return result
          ? [...(result?.data.rows || []).map(({ id }) => ({ type: tagType, id })), { type: tagType, id: 'LIST' }]
          : [{ type: tagType, id: 'LIST' }];
      },
    }),
  }),
});

export const { useGetAllTransactionMethodsQuery, useLazyGetAllTransactionMethodsQuery } = transactionMethodApiServicer;
